import { render, staticRenderFns } from "./govNewsList.vue?vue&type=template&id=f996c132&scoped=true"
import script from "./govNewsList.vue?vue&type=script&lang=js"
export * from "./govNewsList.vue?vue&type=script&lang=js"
import style0 from "./govNewsList.vue?vue&type=style&index=0&id=f996c132&prod&lang=scss"
import style1 from "./govNewsList.vue?vue&type=style&index=1&id=f996c132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f996c132",
  null
  
)

export default component.exports